import { StyleSheet, Font } from '@react-pdf/renderer';
// import FontBlack from "../../assets/fonts/font-bold.ttf";
// import FontRegular from "../../assets/fonts/font-primary.ttf";

// Font.register({ family: 'fontBold', src: FontBlack });
// Font.register({ family: 'fontRegular', src: FontRegular });

const styles = StyleSheet.create({
  document: {
    width: "100%",
    height: "105vh",
  },
  page: {
    padding: "4% 3%",
  },

  reportHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "2%"
  },

  reportHeaderImg: {
    width: "100px",
    position: "absolute",
    top: "0%",
    right: "2%",
  },

  reportHeaderText: {
    // fontFamily: "fontBold",
    textAlign: "left",
    fontSize: "37px",
    marginLeft: "10px"
  },

  headerContainer: {
    display: "flex",
    flexDirection: "row",
    margin: "8% 0 3% 0",
  },

  headerLeftContainer: {
    flex: 2.5,
    display: 'flex',
    marginLeft: "10px"
  },

  chartContainer: {
    flex: 1,
    margin: "auto",
    position: "relative",
    left: "35px",
  },

  headerLeftContainerFirstText: {
    // fontFamily: "fontBold",
    fontSize: "11px",
    color: "#3F3F3E",
    width: "100%",
    lineHeight: 1.5,
    margin: "3% 0 5% 0"
  },
  headerLeftContainerSecondText: {
    // fontFamily: "fontRegular",
    fontSize: "11px",
    color: "#3F3F3E",
    textAlign: "justify",
    width: "100%",
    marginBottom: "1%",
    lineHeight: 1.5,
  },

  barView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    width: "100%",
    margin: "1% 0 ",
    padding: "0 ",
  },
  barContainer: {
    flex: 1,
    margin: "10px ",
  },
  barTitle: {
    fontSize: "10px",
    margin: "3px 0",
    // fontFamily: "fontBold",
    color: "#3F3F3E",
  },
  barText: {
    textAlign: "justify",
    fontSize: "9.5px",
    // fontFamily: "fontRegular",
    width: "95%",
    lineHeight: 1.5,
    padding: "0 1px",
    color: "#3F3F3E",
    marginTop: "-8px"
  },
  barChart: {
    width: "95%",
  },
  barView1: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "flex-start",
    margin: "1% 0 ",
    padding: "0 ",
  },
  barContainer1: {
    width: "22%",
    flex: "0 0 22%",
    marginBottom: "3%",
    marginRight: "3.0%"
  },

});




export default styles;